export const STORAGE_KEY = 'VF-ZP';
export const NOTIFICATION_BUTTON_LINK = 'ButtonLink';
export const SCROLL_POSITION_KEY = 'scrollPosition';
export const KIP_500_BV_12_UM = 'kip-500-bv-12-um';
export const KIP_500_BV_12 = 'kip-500-bv-12';
export const HELP_ICON_DRAWER = '.contact-flyout__drawer';
export const HELP_ICON_TRIGGER = '#contact-flyout__trigger';
export const ARROW_ICON_HREF = '.mod.mod-anchortop.mod-smooth-anchor-scroll a';
export const ARROW_ICON_BOTTOM = '10px';
export const ARROW_ICON_FLOATING_BTN_BOTTOM = '91px';
export const HELP_ICON_PADDING_BOTTOM = '96px';
export const HELP_ICON_FLOATING_BTN_PADDING_BOTTOM = '171px';
export const OFFER_PIRCE_BUTTON = '.ws10-offer-summary-card__button';
export const ANCHOR_SHOWN = 'anchorShown';
export const VF_COOKIE_DOMAIN = '.vodafone.de';
export const ST_COOKIE_DOMAIN = '.wf-de.vodafone.com';
export const PS_COOKIE_VALUE = 'ps5promo';
export const ARROW_ICON_PARENT = 'mod-smooth-anchor-scroll';
export const WS10_IS_HIDDEN = 'ws10-is-hidden';
export const STEPPER_DATA = {
    stepper3P: {
        labels: {
            0: 'Informieren',
            1: 'Internet-Paket wählen',
            2: 'TV im Warenkorb hinzufügen',
        },
        activeStep: 2,
    },
    stepper2P: {
        labels: {
            0: 'Verfügbarkeit',
            1: 'Router',
            2: 'Angaben',
            3: 'Prüfung',
        },
        activeStep: 1,
    },
};
